<template>
  <div class="class-desc">
    <p class="title" v-if="$store.state.className">{{$store.state.className}}</p>
    <div class="desc">
      <p v-for="p in $store.state.classDesc.split('\n')">{{p}}</p>
    </div>
  </div>
  
</template>

<script>
  export default {
    name: "ClassDesc",
    beforeMount() {
      // console.log('是否首次加载', this.$store.state.firstEntryClassList)

      if(this.$store.state.firstEntryClassList){
        this.$router.replace('/class/list')
      }
    },
    mounted() {
      if(sessionStorage.getItem('successRecogByCourseWare')){
        sessionStorage.removeItem('successRecogByCourseWare')
        this.$router.replace('/class/list')
      }
      if(sessionStorage.getItem('cancelRecogByCourseWare')){
        sessionStorage.removeItem('cancelRecogByCourseWare')
        this.$router.back()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .class-desc {
    padding: 20px 15px;
    text-align: left;
    .title {
      color: #1A1A1A;
      font-size: 17px;
      margin-bottom: 15px;
      line-height: 1;
    }
    .desc {
      color: #666;
      font-size: 15px;
      word-break: break-all;
      p {
        margin-bottom: 10px;
      }
    }
  }

</style>